import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/vote_money_r.png'
import _imports_1 from '../../assets/vote_gift.png'


const _withScopeId = n => (_pushScopeId("data-v-515dcca9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "best_comment_container" }
const _hoisted_2 = { class: "flex-col page" }
const _hoisted_3 = { class: "flex-row group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-col items-start image-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "section_1" }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "image_1"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "image_2"
}, null, -1))
const _hoisted_6 = { class: "flex-col section_2" }
const _hoisted_7 = { class: "flex-col items-center section_3" }
const _hoisted_8 = { class: "group_1" }
const _hoisted_9 = { class: "section_4" }
const _hoisted_10 = { class: "score_user" }
const _hoisted_11 = { class: "score" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("积分抽奖中奖名单")
const _hoisted_13 = { class: "image-container1" }
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "user" }
const _hoisted_17 = { class: "user" }
const _hoisted_18 = { class: "favor" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("发送")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("发送")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_notice_bar = _resolveComponent("van-notice-bar")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_grid_item = _resolveComponent("van-grid-item")!
  const _component_van_grid = _resolveComponent("van-grid")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_notice_bar, {
        scrollable: "",
        text: _ctx.basketEvent.eventExplain,
        mode: "closeable"
      }, null, 8, ["text"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_van_grid, {
                  "column-num": 4,
                  "icon-size": "40px"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                      return (_openBlock(), _createBlock(_component_van_grid_item, {
                        key: item,
                        onClick: ($event: any) => (_ctx.goto(item.name))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_van_image, {
                              src: item.icon
                            }, null, 8, ["src"])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("span", null, _toDisplayString(item.name), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createElementVNode("span", _hoisted_10, "用户积分：" + _toDisplayString(_ctx.user.totalScore), 1),
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_van_button, {
                    class: "exchange",
                    plain: "",
                    type: "danger",
                    onClick: _ctx.scoreChange
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createVNode(_component_van_image, {
                  src: _ctx.commentIcon,
                  alt: "",
                  class: "comment_icon",
                  ref: "vanStart"
                }, null, 8, ["src"]),
                _createVNode(_component_van_list, {
                  class: "van-list-container1",
                  ref: "vanEnd",
                  loading: _ctx.loading,
                  "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
                  offset: "10",
                  finished: _ctx.finished,
                  "finished-text": "没有更多了",
                  onLoad: _ctx.onLoad
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentList, (item) => {
                      return (_openBlock(), _createElementBlock("div", { key: item }, [
                        _createElementVNode("div", _hoisted_13, [
                          (item.avatar === null || item.avatar ==='')
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: this.defaultAvatar,
                                alt: "",
                                class: "comment_avatar"
                              }, null, 8, _hoisted_14))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: item.avatar,
                                alt: "",
                                class: "comment_avatar"
                              }, null, 8, _hoisted_15)),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(item.nickName), 1),
                          _createElementVNode("span", _hoisted_17, _toDisplayString(item.by1), 1)
                        ]),
                        _createVNode(_component_van_field, {
                          "model-value": item.comment,
                          autosize: "",
                          type: "textarea",
                          rows: "1",
                          readonly: "",
                          onClick: ($event: any) => (_ctx.goCommentList(item))
                        }, null, 8, ["model-value", "onClick"]),
                        _createElementVNode("div", _hoisted_18, [
                          (item.answerNum === 0)
                            ? (_openBlock(), _createBlock(_component_van_icon, {
                                key: 0,
                                name: "chat-o",
                                size: "20",
                                style: {"margin-right":"10px"},
                                onClick: ($event: any) => (_ctx.dataTransfer(item))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (item.answerNum != 0)
                            ? (_openBlock(), _createBlock(_component_van_icon, {
                                key: 1,
                                name: "chat-o",
                                size: "20",
                                badge: item.answerNum > 99 ? '99+' : item.answerNum,
                                style: {"margin-right":"10px"},
                                onClick: ($event: any) => (_ctx.dataTransfer(item))
                              }, null, 8, ["badge", "onClick"]))
                            : _createCommentVNode("", true),
                          (item.favorNum === 0)
                            ? (_openBlock(), _createBlock(_component_van_icon, {
                                key: 2,
                                name: "good-job-o",
                                onClick: ($event: any) => (_ctx.clickFavor(item))
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (item.favorNum != 0)
                            ? (_openBlock(), _createBlock(_component_van_icon, {
                                key: 3,
                                name: "good-job",
                                badge: item.favorNum > 99 ? '99+' : item.favorNum,
                                color: "red",
                                onClick: ($event: any) => (_ctx.clickFavor(item))
                              }, null, 8, ["badge", "onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["loading", "finished", "onLoad"]),
                _createVNode(_component_van_popup, {
                  show: _ctx.infoCollect,
                  position: "bottom",
                  style: _normalizeStyle([{"height":"20%"}, {bottom:'40vh'}]),
                  closeable: "",
                  onClickCloseIcon: _cache[4] || (_cache[4] = ($event: any) => (_ctx.infoCollect = false, _ctx.name='', _ctx.card=''))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_cell_group, {
                      inset: "",
                      class: "bottom-nav_user"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_field, {
                          class: "send_comment_user",
                          style: _normalizeStyle([{ height: '6vh'}, {"margin-left":"6vh"}]),
                          modelValue: _ctx.name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
                          autosize: "",
                          placeholder: "请输入真实姓名"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_van_field, {
                          class: "send_comment_user",
                          style: _normalizeStyle([{ height: '6vh'}, {"margin-left":"6vh"}]),
                          modelValue: _ctx.card,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.card) = $event)),
                          autosize: "",
                          placeholder: "请输入身份证号"
                        }, {
                          button: _withCtx(() => [
                            _createVNode(_component_van_button, {
                              size: "small",
                              type: "primary",
                              class: "send_btn_user",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitUser()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_19
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["show"]),
                _createVNode(_component_van_popup, {
                  show: _ctx.showPopUp,
                  position: "bottom",
                  style: {"height":"18%"},
                  closeable: "",
                  onClickCloseIcon: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showPopUp = false, _ctx.answer=''))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_cell_group, {
                      inset: "",
                      class: "bottom-nav"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_field, {
                          class: "send_comment",
                          style: _normalizeStyle([{ height: '6vh'}, {"margin-left":"4vh"}]),
                          modelValue: _ctx.answer,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.answer) = $event)),
                          autosize: "",
                          type: "textarea",
                          placeholder: "友善回复"
                        }, {
                          button: _withCtx(() => [
                            _createVNode(_component_van_button, {
                              size: "small",
                              type: "primary",
                              class: "send_btn",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.answerComment()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_20
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["show"]),
                _createVNode(_component_van_cell_group, {
                  inset: "",
                  class: "bottom-nav"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_field, {
                      class: "send_comment",
                      style: { height: '6vh' },
                      modelValue: _ctx.comment,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.comment) = $event)),
                      autosize: "",
                      type: "textarea",
                      placeholder: "许愿"
                    }, {
                      button: _withCtx(() => [
                        _createVNode(_component_van_button, {
                          size: "small",
                          type: "primary",
                          class: "send_btn",
                          onClick: _ctx.sendComment
                        }, {
                          default: _withCtx(() => [
                            _hoisted_21
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}